export default "__VITE_ASSET__pf5I0d7l__"